import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";
import { RECOIL_PERSIST_KEY } from "../sharedStrings";
import { GuardianUser, StudentUser } from "../types/user";

const { persistAtom } = recoilPersist({
  key: RECOIL_PERSIST_KEY,
});

export type LoginType = "student" | "guardian" | undefined;
export interface EditPwState {
  password: string;
  newPassword: string;
  newPasswordCheck: string;
}

export interface EditIdState {
  userId: string;
}

export const studentUserState = atom<StudentUser>({
  key: `studnetUser`,
  default: {
    id: "",
    tel: "",
    name: "",
    birth: undefined,
    userId: "",
    gender: "",
    password: "",
    schoolId: "",
    userType: "student",
    schoolName: "",
    schoolType: "",
    studentCode: "",
    agreementTime1: "",
    agreementTime2: "",
    studentIdNumber: "",
    guardianAccExist: "1",
  },
  effects_UNSTABLE: [persistAtom],
});

export const guardianUserState = atom<GuardianUser>({
  key: `guardianUser`,
  default: {
    id: "",
    tel: "",
    name: "",
    birth: undefined,
    userId: "",
    password: "",
    userType: "guardian",
    agreementTime1: "",
    agreementTime2: "",
  },
  effects_UNSTABLE: [persistAtom],
});

export const loginTypeState = atom<LoginType>({
  key: "loginTypeState",
  default: undefined,
  effects_UNSTABLE: [persistAtom],
});

export const editIdState = atom<EditIdState>({
  key: `userAccEditId`,
  default: {
    userId: "",
  },
});

export const editPwState = atom<EditPwState>({
  key: `userAccEditPw`,
  default: {
    password: "",
    newPassword: "",
    newPasswordCheck: "",
  },
});
